import React, {useState, useEffect} from 'react';
import {defaultErrorHandler} from '../../../context/context';
import shopifyV1Client from '../../../infrastructure/acerill/shopify-v1-client';
import fieldService from '../../../services/field-service';
import IntegrationScaffold from './integration-scaffold';
import MetafieldMappings from './metafield-mappings';
import SubSection from '../../../libs/react-components-admin/section/sub-section';
import CenteredSpinner from '../../../libs/react-components-admin/spinners/centered-spinner';

const SaveMetafieldsShopifyIntegration = () => {

  const [grantedAccessScopes, setGrantedAccessScopes] = useState();

  useEffect(() => {
    shopifyV1Client.findAccessScopes()
      .then(accessScopes => setGrantedAccessScopes(accessScopes))
      .catch(err => defaultErrorHandler(err));
  }, []);

  const bodyFn = (form, model, updateModelFn) => {
    const sourceFields = (form.fields || [])
      .filter(f => !fieldService.isStaticFieldType(f.fieldType))
      .map(f => ({id: f.id, name: fieldService.fieldDescription(f), fieldType: f.fieldType}));
    return <SubSection title="Metafields" className="mb-3">
      <div className="text-muted mb-2">
        The list of metafields to update when the form is submitted.
      </div>
      {!grantedAccessScopes ?
        <CenteredSpinner/> :
        <MetafieldMappings isSubIntegration={false}
                           grantedAccessScopes={grantedAccessScopes}
                           sourceFields={sourceFields}
                           initialModel={model.mappings}
                           onChange={v => updateModelFn('mappings', v)}/>
      }
    </SubSection>;
  };

  return <IntegrationScaffold title="Integration - Shopify - Save metafields"
                              type="save-metafields"
                              bodyFn={bodyFn}/>
};

export default SaveMetafieldsShopifyIntegration;
